import { usePrivy } from '@privy-io/react-auth';
import { useMemo, useRef } from 'react';

import { type PrivySession } from './privy-session';

export function usePrivySession(): PrivySession {
  const privy = usePrivy();
  // Privy recreates `logout` on re-render; a stable session keeps lifecycle effects from relocking.
  const latest = useRef(privy);
  latest.current = privy;

  return useMemo(
    () => ({
      isActive: () => latest.current.authenticated,
      logout: () => latest.current.logout(),
    }),
    [],
  );
}
